import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { LinkTo } from '@ember/routing';

<template>
  {{pageTitle "Home - Marcemira"}}

  <section id="index" aria-label="Home page welcome">
    <figure class="flip flipped">
      <img src="/img/Marcemira-avatar.svg" alt="Marcelo Mira avatar illustration" width="400" height="400" fetchpriority="high" />
    </figure>

    <div id="todo" class="flip-2 flipped-2">
      <header>
        <strong>{{t "index.hello"}}</strong>
        <span>{{t @controller.randomSalutation}}</span>
      </header>
      <div class="bio">
        {{t "index.bio"}}
      </div>
        <div class="ctas" role="navigation" aria-label="Quick links">
          <a
            href="http://github.com/marcemira"
            title="Marcemira's Github"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit my GitHub profile"
          >
            Checkout my Github
          </a>
          <i aria-hidden="true"> or </i>
          <LinkTo @route="about" aria-label="Learn more about Marcelo Mira">Learn more about me</LinkTo>
        </div>
    </div>
  </section>
</template>
